export const SITE = {
  name: "VirtualPeek®",
  tagline: "Spécialiste de la Visite Virtuelle · Matterport Pro3",
  description:
    "Visites virtuelles 3D immersives (Matterport Pro3) et stratégie de visibilité Google pour valoriser vos espaces et attirer plus de clients qualifiés.",
  portfolioHQ: "https://virtualpeek.pixieset.com/",
  legal: {
    editor: "Jérémy BEL",
    cape: "INCUBATEST PAR BGE OUEST HÉRAULT · SIREN 750 012 155",
    updated: "20 août 2026",
  },
  pro3: {
    panorama: "134,2 Mpx",
    photos: "4K par face (skybox)",
    precision: "±20 mm",
    precisionNote: "profondeur brute à 10 m, selon les spécifications officielles Matterport",
    lidar: "Laser classe 1 · 904 nm · 100 000 points/s",
    range: "0,5 à 100 m",
    rangeNote: "jusqu'à 20 m exploités par scan pour les modèles standards, portée maximale réservée à l'export E57",
    scan: "moins de 20 s par scan",
  },
  phone: "06 41 22 12 57",
  phoneRaw: "0641221257",
  email: "contact@virtualpeek.fr",
  area: "Hérault",
  mascotAbout: "/mascot-pro3.webp",
  mascot: "https://customer-assets.emergentagent.com/job_virtual-peek/artifacts/brdru0fv_Create%20a%20premium%20vertical%209_16%20video%20for%20VirtualPeek___The%20same%20professional%20360_%20camera%20mascot%20pres%20%281%29.png",
  mascotHero: "/mascot-hero.webp",
  mascotPhone: "https://customer-assets-7cd3h4nn.emergentagent.net/wingman/264bb659-d8a5-482c-88dd-f0774d60d9cf/attachments/4b9c84d4359b41ce979e7bbee158e4c3_ChatGPT%20Image%2011%20ao_t%202026%2C%2014_17_02.png",
  logoMark: "https://customer-assets.emergentagent.com/job_virtual-peek/artifacts/iz5ca32r_IMG_7894.jpeg",
  logoFull: "/logo-virtualpeek.webp",
  googleBusinessUrl:
    "https://www.google.com/search?q=VirtualPeek&stick=H4sIAAAAAAAA_-NgU1I1qLAwtjBJMjKyNDJOS01LtrS0MqgwSUwzNE81sDQzsTSzNE81XcTKHZZZVFKamBOQmpoNAH0DY5s3AAAA&hl=fr",
  googleReviewUrl: "https://g.page/r/CeWXlmQJfvFKEAE/review",
  social: {
    instagram: "https://instagram.com/virtualpeek34",
    facebook: "https://facebook.com/Virtualpeek",
    linkedin: "https://linkedin.com/in/virtual-peek-3ab8b13a1",
    tiktok: "https://tiktok.com/@virtualpeek0",
    youtube: "https://youtube.com/channel/UCYCjwaFWJ06367sH1jIjZaA",
  },
};

export const SERVICES = [
  {
    key: "visite",
    title: "Visite Virtuelle 3D immersive 360°",
    subtitle: "Matterport Pro 3",
    paras: [
      "Votre espace reste visitable 24h/24, 7j/7, depuis un simple lien : aucune application à installer, sur smartphone, tablette ou ordinateur.",
      "Vos prospects explorent librement chaque pièce, comprennent les volumes et reviennent autant de fois qu'ils le souhaitent — maison, appartement, commerce, hôtel, restaurant, camping-car ou véhicule.",
      "Résultat : des visiteurs déjà informés et convaincus avant même de vous appeler ou de se déplacer.",
    ],
    highlights: [
      "Explorer les lieux à distance",
      "Comprendre les volumes et l'agencement",
      "Préparer sa visite ou sa prise de contact",
    ],
  },
  {
    key: "photos",
    title: "Photos Haute Qualité",
    subtitle: "Extraits 4K",
    paras: [
      "Des visuels professionnels extraits directement de la visite virtuelle : une cohérence parfaite entre vos photos et votre visite 360°. Comptez 20 à 30 photos 4K selon le bien.",
    ],
    highlights: [
      "Recevoir un lien et des photos prêts à diffuser",
      "Des visuels cohérents avec la visite",
      "Livrés avec la visite, sans rendez-vous supplémentaire",
    ],
    external: "https://virtualpeek.pixieset.com/",
    cta: "Découvrir nos extractions photos",
  },
  {
    key: "leads",
    title: "Qualification de Visites Virtuelles",
    subtitle: "VirtualPeek® Leads",
    paras: [
      "Chaque visite virtuelle devient un véritable point de contact commercial : le prospect découvre le bien en immersion après signature d'un bon de visite virtuel.",
      "Il renseigne ses coordonnées et précise son projet (bien recherché, avancement, financement) avant de poursuivre la visite. Vous recevez immédiatement un lead contextualisé et engagé.",
      "Pensé pour les agences, mandataires et vendeurs qui diffusent sur Leboncoin, SeLoger, ParuVendu, Logic-Immo ou Le Figaro Immobilier.",
    ],
    highlights: [
      "Bon de visite virtuel signé avant la visite",
      "Coordonnées et projet renseignés par le prospect",
      "Un espace pour suivre vos biens, visites et contacts",
    ],
    external: "https://visite-virtuelle.virtualpeek.fr",
    cta: "Découvrir visite-virtuelle.virtualpeek.fr",
  },
];

export const PORTFOLIO = [
  {
    title: "Institut G2M Cosmétique",
    city: "Gignac",
    category: "Beauté",
    url: "https://my.matterport.com/show/?m=94o2hQb26s1",
    image: "https://images.unsplash.com/photo-1560066984-138dadb4c035?w=640&q=70&auto=format",
  },
  {
    title: "M.B.R Barber Shop",
    city: "Gignac",
    category: "Commerce",
    url: "https://my.matterport.com/show/?m=p1WXbHXAL1w",
    image: "https://images.unsplash.com/photo-1585747860715-2ba37e788b70?w=640&q=70&auto=format",
  },
  {
    title: "231 East Street",
    city: "Clermont l'Hérault",
    category: "Restaurant",
    url: "https://my.matterport.com/show/?m=U2wJqdL2h5V",
    image: "https://images.unsplash.com/photo-1552566626-52f8b828add9?w=640&q=70&auto=format",
  },
  {
    title: "Hair Break",
    city: "Clermont l'Hérault",
    category: "Commerce",
    url: "https://my.matterport.com/show/?m=43Fby6a6VPW",
    image: "https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f?w=640&q=70&auto=format",
  },
  {
    title: "Maison +200 m²",
    city: "Clermont l'Hérault",
    category: "Immobilier",
    url: "https://my.matterport.com/show/?m=dushF7ayAGB",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=640&q=70&auto=format",
  },
  {
    title: "Mobil-home Airbnb",
    city: "Vias",
    category: "Immobilier",
    url: "https://my.matterport.com/show/?m=PmuSnt1t31U",
    image: "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=640&q=70&auto=format",
  },
  {
    title: "Studio Airbnb",
    city: "Agde",
    category: "Immobilier",
    url: "https://my.matterport.com/show/?m=pQRKPmLdEmx",
    image: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=640&q=70&auto=format",
  },
  {
    title: "Fleurs et Déco",
    city: "Gignac",
    category: "Commerce",
    url: "https://my.matterport.com/show/?m=KBkL4A43QcM",
    image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=640&q=70&auto=format",
  },
  {
    title: "Tente Lodge — Domaine du chêne",
    city: "Campagnan",
    category: "Hôtellerie",
    url: "https://my.matterport.com/show/?m=iqSV7CvJdnZ",
    image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=640&q=70&auto=format",
  },
];

export const PRICING_INCLUDES = [
  { label: "Déplacement inclus (Hérault)" },
  { label: "20 à 30 photos 4K extraites de la visite virtuelle" },
  { label: "Hébergement inclus pendant 12 mois, puis 79 € HT/an" },
  {
    label: "Plan 2D inclus",
    detail: "Visualisez facilement l'agencement et la disposition des espaces de votre bien.",
  },
  {
    label: "Vues 3D Dollhouse incluses",
    detail: "Découvrez votre propriété sous tous les angles grâce à une représentation 3D spectaculaire, comme une maison de poupée.",
  },
];

// Option facultative du simulateur : extension de la visite aux espaces extérieurs.
export const OUTDOOR_OPTION = {
  title: "Sublimez également vos extérieurs",
  description:
    "Prolongez l'expérience immersive au-delà des murs ! Terrasse, jardin, piscine ou espaces de détente : offrez une découverte complète de votre propriété grâce à une visite virtuelle intégrant également vos extérieurs.",
  cta: "Ajouter les extérieurs — 50 € HT",
  price: 50,
  maxSurface: 800,
  notice: "Offre réservée aux espaces extérieurs de moins de 800 m², sous réserve de faisabilité technique.",
  tooLarge: "Pour les grands espaces extérieurs, contactez-nous afin d'obtenir une étude personnalisée.",
};

// Conditions d'hébergement confirmées (CGV art. 9 + tarif de reconduction)
export const HOSTING = {
  short: "Hébergement inclus pendant 12 mois, puis 79 € HT/an.",
  start: "Les 12 mois courent à compter de la livraison de votre visite.",
  renew: "Au terme des 12 mois, une reconduction annuelle vous est proposée à 79 € HT par an.",
  noRenew:
    "Sans reconduction, le lien de la visite est désactivé au terme (conditions générales, article 9).",
};

// Bloc commun « Ce que comprend votre prestation » — uniquement des éléments confirmés
export const PRESTATION_INCLUDES = [
  {
    title: "Ce que vous recevez",
    items: [
      "La visite virtuelle Matterport de votre bien, hébergée et accessible 24 h/24 depuis un simple lien.",
      "Les photos 4K extraites de la visite virtuelle, prêtes à être publiées : 20 à 30 visuels selon le bien.",
      "Le déplacement sur place dans l'Hérault, compris dans le prix affiché.",
      "La livraison sous 48 h ouvrées après la captation.",
    ],
  },
  {
    title: "Hébergement de la visite",
    items: [
      "Votre prestation comprend les 12 premiers mois d'hébergement de la visite virtuelle. Au-delà, l'hébergement coûte 79 € HT par an.",
      "Les 12 mois courent à compter de la livraison de votre visite.",
      "Au terme des 12 mois, une reconduction annuelle vous est proposée à 79 € HT par an. Sans reconduction, le lien de la visite est désactivé au terme (conditions générales, article 9).",
    ],
  },
  {
    title: "Diffusion de votre visite",
    items: [
      "Vous recevez le lien de votre visite, prêt à être partagé par e-mail, sur vos annonces ou sur vos réseaux.",
      "Code d'intégration pour votre site, mise en ligne par nos soins ou publication sur votre fiche Google : indiquez-le dans votre demande, nous le chiffrons avec votre devis.",
    ],
  },
  {
    title: "Services distincts",
    items: [
      "La qualification de prospects (VirtualPeek Leads) est un service distinct, non inclus dans la prestation de visite virtuelle.",
      "Les maisons et appartements sont facturés selon leur surface ; les autres univers (commerces, hébergements, véhicules…) suivent un forfait par catégorie ou un devis.",
    ],
  },
];

// Définition unique des paliers par surface — utilisée par le simulateur ET les cartes Tarifs.
export const SURFACE_TIERS = [
  { name: "Compact", max: 70, label: "Jusqu'à 70 m²", price: "199€", priceSuffix: "HT", amount: 199 },
  { name: "Standard", max: 130, label: "De 71 à 130 m²", price: "249€", priceSuffix: "HT", amount: 249 },
  { name: "Large", max: 199, label: "De 131 à 199 m²", price: "299€", priceSuffix: "HT", amount: 299 },
  { name: "Premium", max: Infinity, label: "200 m² et plus", price: "Sur devis", priceSuffix: "", amount: null },
];

export function simulateQuote(surface) {
  const s = Number(surface);
  if (!s || s <= 0) return null;
  const tier = SURFACE_TIERS.find((t) => s <= t.max);
  const premium = tier.name === "Premium";
  return {
    tier: tier.name,
    price: premium ? "Contactez-nous pour un devis Premium" : tier.price,
    suffix: premium ? "" : tier.priceSuffix,
    amount: tier.amount,
    premium,
  };
}

export const PRICING = [
  {
    name: "Compact",
    surface: "Jusqu'à 70 m²",
    price: "199€",
    priceSuffix: "HT",
    features: [
      "Visite virtuelle Matterport",
      "20 à 30 photos 4K extraites de la visite virtuelle",
      "Plan 2D du bien inclus",
      "Vues 3D Dollhouse incluses",
      "Hébergement inclus 12 mois, puis 79 € HT/an",
      "Livraison sous 48 h ouvrées",
      "Lien de visite prêt à partager",
    ],
    cta: "Demander un devis",
    popular: false,
  },
  {
    name: "Standard",
    surface: "De 71 à 130 m²",
    price: "249€",
    priceSuffix: "HT",
    features: [
      "Visite virtuelle Matterport",
      "20 à 30 photos 4K extraites de la visite virtuelle",
      "Plan 2D du bien inclus",
      "Vues 3D Dollhouse incluses",
      "Hébergement inclus 12 mois, puis 79 € HT/an",
      "Livraison sous 48 h ouvrées",
      "Lien de visite prêt à partager",
    ],
    cta: "Demander un devis",
    popular: true,
  },
  {
    name: "Large",
    surface: "De 131 à 199 m²",
    price: "299€",
    priceSuffix: "HT",
    features: [
      "Visite virtuelle Matterport",
      "20 à 30 photos 4K extraites de la visite virtuelle",
      "Plan 2D du bien inclus",
      "Vues 3D Dollhouse incluses",
      "Hébergement inclus 12 mois, puis 79 € HT/an",
      "Livraison sous 48 h ouvrées",
      "Lien de visite prêt à partager",
    ],
    cta: "Demander un devis",
    popular: false,
  },
  {
    name: "Premium",
    surface: "200 m² et plus",
    price: "Sur devis",
    priceSuffix: "",
    features: [
      "Visite virtuelle Matterport",
      "20 à 30 photos 4K extraites de la visite virtuelle",
      "Plan 2D du bien inclus",
      "Vues 3D Dollhouse incluses",
      "Hébergement inclus 12 mois, puis 79 € HT/an",
      "Délai de livraison précisé dans le devis",
      "Lien de visite prêt à partager",
    ],
    cta: "Discuter de mon projet",
    popular: false,
  },
];

export const FAQ_ITEMS = [
  {
    q: "Qu'est-ce qu'une visite virtuelle Matterport ?",
    a: "C'est une reproduction 3D fidèle et immersive d'un espace, navigable à 360°. Vos visiteurs peuvent explorer le lieu depuis n'importe quel appareil, à toute heure, comme s'ils y étaient.",
  },
  {
    q: "Quel matériel utilisez-vous ?",
    a: "La caméra Matterport Pro3, référence du marché, avec technologie LiDAR intégrée. Elle scanne aussi bien les intérieurs que les extérieurs ; le détail de ses caractéristiques est présenté dans la section « La technologie derrière chaque visite » sur la page d'accueil.",
  },
  {
    q: "Quel est le délai de livraison ?",
    a: "Un dossier complet (visite virtuelle, 20 à 30 photos 4K extraites, lien de diffusion) est livré sous 48 heures ouvrées après la captation.",
  },
  {
    q: "À qui s'adresse VirtualPeek ?",
    a: "Aux professionnels (agences immobilières, restaurants, hôtels, gîtes, campings, commerces, instituts, écoles) et aux particuliers (vente immobilière, location Airbnb).",
  },
  {
    q: "Où intervenez-vous ?",
    a: "Principalement dans l'Hérault et les départements limitrophes. Pour les missions hors zone, contactez-nous pour un devis personnalisé.",
  },
];

export const COVERED_CITIES = [
  { name: "Montpellier", featured: true },
  { name: "Béziers", featured: true },
  { name: "Clermont l'Hérault", featured: true },
  { name: "Gignac", featured: true },
  { name: "Agde", featured: true },
  { name: "Sète", featured: false },
  { name: "Lodève", featured: false },
  { name: "Pézenas", featured: false },
  { name: "Vias", featured: false },
  { name: "Campagnan", featured: false },
  { name: "Frontignan", featured: false },
  { name: "Mèze", featured: false },
  { name: "Lunel", featured: false },
  { name: "Ganges", featured: false },
];

export const LIVE_STATS = {
  scanned: 42,
  clients: 28,
  cities: 14,
  sqm: 4800,
};

export const ARTICLES = [
  {
    slug: "5-astuces-preparer-bien-scan-matterport",
    title: "5 astuces pour préparer votre bien avant le scan Matterport",
    cat: "Immobilier",
    date: "15 janv. 2026",
    read: "4 min",
    cover: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=1000&q=72&auto=format",
    excerpt: "Rangement, éclairage, ambiance : les gestes qui font la différence pour une visite virtuelle qui vend.",
    intro: "Le scan Matterport capture tout, dans les moindres détails. Autant dire qu'une bonne préparation en amont fait toute la différence entre une visite virtuelle qui séduit… et une qui repousse.",
    sections: [
      { h: "1. Désencombrez, ne dépersonnalisez pas", p: "L'objectif n'est pas de vider l'espace — c'est de le rendre lisible. Rangez ce qui traîne, cachez les câbles, retirez les objets trop personnels (photos de famille, courrier). Laissez juste ce qu'il faut pour que le visiteur se projette : quelques livres, une plante, un tapis, du linge propre plié." },
      { h: "2. Ouvrez la lumière, partout", p: "Ouvrez tous les volets et rideaux, allumez toutes les lampes — y compris celles qu'on n'allume jamais en journée. Une pièce lumineuse paraît plus grande, plus accueillante et rend beaucoup mieux en 3D. Évitez cependant le contre-jour direct qui perturbe le capteur." },
      { h: "3. Nettoyez surfaces réfléchissantes et sols", p: "Miroirs, vitres, plans de travail, sols brillants : tout ce qui brille se voit deux fois plus en visite virtuelle. Un coup de chiffon microfibre 30 minutes avant la captation fait des miracles." },
      { h: "4. Pensez « ambiance de vente »", p: "Une bougie allumée, un plaid posé sur le canapé, une table dressée, des fruits dans une coupe : ces petites touches créent l'émotion qui déclenche la visite physique. C'est la même logique qu'une photo pro." },
      { h: "5. Isolez les animaux et prévenez les voisins", p: "Le scan dure entre 45 min et 2h selon la surface. Prévoyez un lieu calme pour vos animaux et, si vous êtes en copropriété, prévenez que quelqu'un va se déplacer avec un trépied dans les parties communes." },
    ],
    conclusion: "Une préparation soignée, c'est +30% de qualité perçue sur la visite finale. Et une visite qui inspire confiance, c'est un contact qualifié en plus dans votre pipeline.",
  },
  {
    slug: "visite-virtuelle-booste-fiche-google-business",
    title: "Comment votre visite virtuelle booste votre fiche Google Business",
    cat: "Google Business",
    date: "02 févr. 2026",
    read: "5 min",
    cover: "https://images.unsplash.com/photo-1611926653458-09294b3142bf?w=1000&q=72&auto=format",
    excerpt: "Signal d'engagement, temps passé, taux de clic : ce que Google mesure vraiment quand une visite est intégrée.",
    intro: "Google Business Profile est devenu le canal n°1 de découverte locale. Mais entre les fiches concurrentes, comment sortir du lot ? La visite virtuelle 3D est aujourd'hui l'un des leviers les plus sous-exploités par les commerces de proximité.",
    sections: [
      { h: "Ce que Google mesure réellement", p: "Le référencement local repose sur trois piliers : la pertinence, la proximité et l'engagement. Les deux premiers, vous les subissez. Le troisième, vous pouvez l'activer. Temps passé sur la fiche, clics vers le site, appels, demandes d'itinéraire : tout signale à Google que votre fiche est utile." },
      { h: "Pourquoi la visite change la donne", p: "Une visite virtuelle intégrée retient les visiteurs 3 à 5 fois plus longtemps qu'une simple galerie photo. Elle réduit les hésitations, répond aux questions muettes (ambiance, taille, accessibilité) et transforme une curiosité en clic vers votre site ou appel." },
      { h: "L'effet cumulatif sur le classement local", p: "Google ne remonte pas les fiches qui ont juste des photos — il remonte celles qui génèrent de l'engagement. Ajoutez à ça les avis positifs déclenchés par une visite bluffante, et vous cumulez deux signaux forts : engagement + réputation." },
      { h: "Intégration technique en 2 clics", p: "Depuis votre back-office Matterport, on récupère le lien de partage et on le rattache à votre fiche via la console Google Business. La visite apparaît alors directement dans les résultats de recherche et sur Google Maps — même sur mobile." },
      { h: "Cas concret", p: "Un institut de beauté à Gignac a vu son taux de clic vers le site augmenter de 47% dans les 3 mois suivant l'intégration de sa visite virtuelle, et le nombre de nouveaux clients issus de Google Maps doubler sur la même période." },
    ],
    conclusion: "Investir dans une visite virtuelle, ce n'est pas payer pour une belle vitrine — c'est acheter des signaux d'engagement qui rebattent les cartes du référencement local. Un ROI mesurable, souvent en moins de 90 jours.",
  },
  {
    slug: "restaurant-commerce-capturer-ambiance",
    title: "Restaurant & commerce : capturer l'ambiance avant tout",
    cat: "Commerce",
    date: "18 févr. 2026",
    read: "4 min",
    cover: "https://images.unsplash.com/photo-1552566626-52f8b828add9?w=1000&q=72&auto=format",
    excerpt: "L'ambiance vend autant que la carte. Voici comment la retranscrire fidèlement en 3D.",
    intro: "Dans la restauration ou le commerce de bouche, on ne vend pas seulement un produit ou un plat — on vend une expérience. Et cette expérience commence bien avant que le client franchisse la porte : elle commence sur son écran.",
    sections: [
      { h: "L'ambiance, ce que la photo ne montre pas", p: "Une photo fige un instant. Une visite virtuelle fait ressentir un lieu — sa circulation, sa lumière, ses volumes, la proximité entre les tables. C'est ce qui transforme un « je regarde » en « je réserve »." },
      { h: "Le bon moment pour capturer", p: "Idéalement en journée avec la lumière naturelle, mais en configuration « prêt à ouvrir » : tables dressées, ardoise du jour visible, bar allumé, décoration en place. Évitez les heures de service — l'espace doit être calme pour un scan propre." },
      { h: "Mettez en scène vos différenciateurs", p: "Un four à bois visible depuis la salle ? Cadrez-le. Une cave à vin apparente ? Elle doit être dans le parcours. Une terrasse cachée ? On la met en avant. La visite virtuelle raconte votre histoire, à vous de la mettre en scène." },
      { h: "Les détails qui rassurent", p: "Menu affiché lisiblement, cartes de paiement acceptées, accessibilité PMR, place de parking : autant d'infos que le visiteur cherche discrètement. Une visite virtuelle bien pensée les rend visibles sans les surligner." },
    ],
    conclusion: "L'ambiance ne se décrit pas, elle se ressent. Une visite virtuelle réussie donne au visiteur l'impression d'y être déjà — et déclenche la vraie visite. Celle qui compte.",
  },
  {
    slug: "airbnb-visite-virtuelle-augmente-reservations",
    title: "Airbnb : la visite virtuelle qui augmente vos réservations",
    cat: "Airbnb",
    date: "05 mars 2026",
    read: "5 min",
    cover: "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=1000&q=72&auto=format",
    excerpt: "Se démarquer sur un marché saturé : notre méthode pour booster les conversions sur vos annonces.",
    intro: "Sur Airbnb, Booking ou Abritel, la concurrence est féroce. À prix et localisation équivalents, ce qui fait la différence, c'est la capacité à rassurer le voyageur avant qu'il ne clique sur « réserver ». Et rien ne rassure comme une visite virtuelle.",
    sections: [
      { h: "Le voyageur veut voir avant de payer", p: "Un voyageur qui hésite entre 5 logements passe en moyenne 30 secondes sur chaque annonce. Une visite virtuelle capte son attention et le retient : il explore, se projette, imagine ses vacances. Ce temps supplémentaire change tout." },
      { h: "Réduire drastiquement les mauvaises surprises", p: "Les mauvais commentaires viennent souvent d'un décalage entre les photos et la réalité (taille des pièces, disposition, luminosité). Avec une visite virtuelle, plus de doute : le voyageur voit exactement ce qu'il réserve." },
      { h: "Où intégrer la visite virtuelle ?", p: "Sur votre site direct (essentiel pour les hôtes qui veulent éviter les commissions), sur votre fiche Google Business si vous êtes hôte pro, sur vos réseaux, dans vos emails de suivi, et en QR code sur votre livret d'accueil pour les futurs invités." },
      { h: "Le ROI concret", p: "Nos hôtes constatent en moyenne +20 à +35% de taux de conversion sur leur site direct, une baisse des annulations, et surtout — moins de questions récurrentes avant réservation. Le voyageur sait déjà tout." },
      { h: "Astuce : jouez la carte de l'authenticité", p: "Contrairement aux photos retouchées, la visite virtuelle est perçue comme honnête. C'est ce qui inspire confiance en 2026. Un logement montré tel qu'il est, c'est un voyageur qui arrive avec le sourire." },
    ],
    conclusion: "Dans un marché saturé, la visite virtuelle n'est plus un « bonus » — c'est un standard qui sépare les annonces qui convertissent de celles qu'on scrolle. Et pour 199€ à 299€, l'investissement est rentabilisé en 1 ou 2 réservations.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Carole R.",
    company: "La vie est BEL by Carole — Gignac",
    text: "Une prestation au top, professionnelle et rapide. La visite virtuelle attire vraiment l'attention sur ma fiche Google.",
    rating: 5,
  },
  {
    name: "Mehdi B.",
    company: "M.B.R Barber Shop — Gignac",
    text: "Le rendu est bluffant. Mes clients me parlent de la visite et ma visibilité Google a clairement progressé.",
    rating: 5,
  },
  {
    name: "Hair Break",
    company: "Clermont l'Hérault",
    text: "Service de qualité, livraison rapide et un vrai coup de pouce pour notre image en ligne. Je recommande sans hésiter.",
    rating: 5,
  },
  {
    name: "Alexandre M.",
    company: "231 East Street — Clermont l'Hérault",
    text: "Jérémy est très professionnel, à l'écoute et le résultat est à la hauteur. La visite met vraiment le restaurant en valeur.",
    rating: 5,
  },
  {
    name: "Sandra L.",
    company: "Fleurs et Déco — Gignac",
    text: "Un accompagnement sérieux du début à la fin. La visite virtuelle est un vrai plus pour se démarquer sur Google.",
    rating: 5,
  },
  {
    name: "Domaine du Chêne",
    company: "Campagnan",
    text: "Excellent travail sur nos tentes lodges, la visite 3D permet aux clients de se projeter avant même de réserver. Merci !",
    rating: 5,
  },
];
